import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import type { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";

export const getCountOfObjects = (
  objects: NormalizedStorageObject<StorageObjectValue>[],
): number =>
  objects.reduce((acc, object) => {
    if (object.value !== null) return acc + 1;
    return acc;
  }, 0);

export const getCountOfFolders = (
  objects: NormalizedStorageObject<StorageObjectValue>[],
): number => objects.filter((object) => object.value === null).length;
